import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { SocialWebDomainsWidget as SocialWebDomainsWidgetType } from 'schemas/SocialWebDomainsWidgetSchema'

import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getLabel } from 'utils/widgetTypeUtil'
import { WidgetLoadingGuard } from '../share/guards'
import DomainsWidgetSettingGuards from './guards/DomainsWidgetSettingGuards'
import DomainsWidgetDataGuards from './guards/DomainsWidgetDataGuards'
import RunSearchEffect from './RunSearchEffect'
import Domains from './Domains'
import InsightModal from './InsightModal'
import useSelectedInsights from './InsightModal/hooks/useSelectedInsights'

interface SocialWebDomainsWidgetProps {
  widgetId: number
}

const SocialWebDomainsWidget = ({ widgetId }: SocialWebDomainsWidgetProps) => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebDomainsWidgetType>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <DomainsWidgetSettingGuards widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <DomainsWidgetDataGuards widgetId={widgetId}>
              <Domains widgetId={widgetId} onClick={onClick} />
            </DomainsWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </DomainsWidgetSettingGuards>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={widgetSetting?.countType}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebDomainsWidget
